import { useQuery } from "react-query";
import { design } from "@/services/design";
import { useStore } from "zustand";
import { useUserState } from "@/states/user.state";
import { DEBUGGER } from "@/helper/helper";

const useLogo = () => {
  const guestToken = useStore(useUserState, (state) => state.guestToken);
  const { data, isLoading } = useQuery(["USER_LOGO"], design.getLogo, {
    enabled: !!guestToken,
    onError: (error: unknown) => {
      DEBUGGER("Error fetching logo => ", error);
    },
  });

  return {
    data,
    isLoading,
  };
};

export default useLogo;
